import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["semanticColor", "condensed"];
import React from 'react';
import styled from 'styled-components';
import { ButtonTertiary } from "../ButtonTertiary";
var EmptyStateButtonComponent = styled(ButtonTertiary).withConfig({
  displayName: "EmptyStateButton__EmptyStateButtonComponent",
  componentId: "sc-1m67ey1-0"
})(["margin-block-end:-17px;margin-block-start:7px;max-inline-size:100%;overflow-wrap:break-word;"]);
export var EmptyStateButton = function EmptyStateButton(_ref) {
  var _ref$semanticColor = _ref.semanticColor,
      semanticColor = _ref$semanticColor === void 0 ? 'textBrightAccent' : _ref$semanticColor,
      _ref$condensed = _ref.condensed,
      condensed = _ref$condensed === void 0 ? true : _ref$condensed,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(EmptyStateButtonComponent, Object.assign({
    semanticColor: semanticColor,
    condensed: condensed
  }, props));
};
/**
* **EmptyStateButton** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/EmptyStateButton) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-emptystate-emptystatebutton--default) |  
*
* EmptyStateButton is a CTA a user can take.
*
* @example
* () => <EmptyStateButton>Do something!</EmptyStateButton>;
*
*/

export default EmptyStateButton;